module.exports = __webpack_public_path__ + "static/media/W19-1154_AW_BMAwareness_Mobile_767x845_EN.253fe4ca.jpg";